var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "141.96 105.61 115.97 105.61 115.97 79.62 98.47 79.62 98.47 105.61 72.48 105.61 72.48 123.11 98.47 123.11 98.47 149.1 115.97 149.1 115.97 123.11 141.96 123.11 141.96 105.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.22,25.58S91.88,58.15,37.91,58.15c0,0-4.09,38,3.72,72.33,6.46,28.34,25.63,49.09,65,62.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.08,25.58s15.33,32.57,69.31,32.57c0,0,4.09,38-3.73,72.33-6.46,28.34-25.63,49.09-65,62.55"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/INSURANCE.8f738322088f268c3d943b54bffafccd.svg";
export { ForwardRef as ReactComponent };